import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";
import { features } from "@/mocks/home";

export default function FeaturedFlowSection() {
  return (
    <section id="investigation" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <SectionHeading
            index="02"
            eyebrow="Investigation"
            title="深度调查 · 大图连载"
            description="每一篇都从线报出发，用可核验的材料还原现场。我们只写查得到、对得上的那部分。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-x-7 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
          {features.map((item, index) => (
            <Reveal key={item.title} delay={index * 80}>
              <article className="group flex h-full flex-col">
                <div className="relative h-[240px] w-full overflow-hidden rounded-lg bg-foreground-950 md:h-[300px]">
                  <img
                    src={item.image}
                    alt={`黑网爆料深度调查：${item.title}`}
                    title={`${item.title} 黑网爆料黑色产业链`}
                    className="h-full w-full object-cover object-top transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
                  <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col pt-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{item.date}</span>
                    <span className="h-3 w-px bg-background-400"></span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.readTime}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg leading-8 text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">
                    {item.excerpt}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary-600">
                    阅读全文
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}